export const getUser = (data) => ({
  type: 'AUTH_GET_USER',
  data
});

export const getUserFailed = (error) => ({
  type: 'AUTH_GET_USER_FAILED',
  error
});

export const logout = (params) => ({
  type: 'AUTH_LOGOUT',
  data: params
});

export const logoutAll = (params) => ({
  type: 'AUTH_LOGOUT_ALL',
  data: params
});

export const login = (data) => ({
  type: 'AUTH_LOGIN',
  data
});

export const emulate = (data) => ({
  type: 'AUTH_START_EMULATION',
  data
});

export const loginFailed = (error) => ({
  type: 'AUTH_LOGIN_FAILED',
  error
});

export const setCurrentUser = (user, brandNew = false) => ({
  type: 'AUTH_SET_CURRENT_USER',
  user,
  brandNew
});

export const updateUser = (updates) => ({
  type: 'AUTH_UPDATE_CURRENT_USER',
  updates
});

export const setThirdPartyScripts = ({ enableGlia, liveEngageKey }) => ({
  type: 'AUTH_THIRD_PARTY_INTEGRATIONS',
  liveEngageKey,
  enableGlia
});
